






import { Component, Vue, Watch } from 'nuxt-property-decorator'
import BlogList from '~/components/Blog/BlogList.vue'
import { getItemsByLang } from '~/data/blogs/conversion'
import * as BlogUtils from '~/utils/BlogUtils'
import { createHead } from '~/helpers/SeoUtils'
import * as PostsUtils from '~/utils/PostsUtils'
import PostList from '~/components/Post/PostList.vue'

@Component({
  name: 'BlogArchivePage',
  components: { PostList },
  watchQuery: true
})
export default class extends Vue {
  head() {
    if (this.list === null || this.list.length === 0) return null
    const item = this.list[0]
    const postDate = new Date(item.PublishedAt)
    const date = new Date(
      Date.UTC(postDate.getUTCFullYear(), postDate.getUTCMonth())
    )
    const dateFormatted = new Intl.DateTimeFormat(this.$i18n.locale, {
      year: 'numeric',
      month: 'long'
    }).format(date)
    return createHead({
      Title: dateFormatted + ' | ' + this.$t('BlogPage.Hero.Title'),
      UseDefaultTitlePostfix: true
    })
  }

  list = []
  get archive() {
    return this.$route.params.archive
  }

  async asyncData({ params, query, app, $axios, $i18n, error }) {
    const archive = params.archive
    const language = PostsUtils.getLangToLoadByLocale(app.i18n._vm._data.locale)
    const r = await $axios.$get(`/api/posts/Blog/${language}`, {
      params: {
        archive
      }
    })
    return {
      list: r.Data
    }
  }
}
